import { useTranslation } from 'react-i18next'
import { useState } from 'react'

import { AcknowledgeModal, ConfirmationModal, Modal } from '@percent/lemonade'
import { RecalculateProgramModalProps } from './RecalculateProgramModal.types'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { useMutation } from '@percent/utility'

export function RecalculateProgramModal({ open, setOpen, programId }: Readonly<RecalculateProgramModalProps>) {
  const [modalState, setModalState] = useState<'success' | 'error' | null>(null)

  const { grantProgramService } = useServices()
  const { t } = useTranslation()

  const [{ isPending }, { apiFunc: recalculateProgram }] = useMutation(
    grantProgramService.recalculateProgram,
    () => setModalState('success'),
    () => setModalState('error')
  )

  const handleClose = () => {
    setOpen(false)
    setModalState(null)
  }

  const successModal = modalState === 'success' && (
    <AcknowledgeModal
      result="positive"
      title={t('grants.programDetails.recalculate.success.title')}
      buttonText={t('button.close')}
      handleClose={handleClose}
      viewTestId="recalculate-program-success-modal"
      buttonTestId="close-recalculate-program-success-modal"
    />
  )

  const errorModal = modalState === 'error' && (
    <AcknowledgeModal
      result="negative"
      title={t('grants.programDetails.recalculate.error.title')}
      buttonText={t('button.done')}
      handleClose={handleClose}
      viewTestId="recalculate-program-error-modal"
      buttonTestId="close-recalculate-program-error-modal"
    />
  )

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      {successModal || errorModal || (
        <ConfirmationModal
          title={t('grants.programDetails.recalculate.title')}
          loading={isPending}
          primaryButtonText={t('button.recalculate')}
          primaryBtnTestId="recalculate-program-modal-button"
          secondaryButtonText={t('button.cancel')}
          handleSubmit={() => recalculateProgram({ programId })}
          handleClose={handleClose}
        >
          {t('grants.programDetails.recalculate.description')}
        </ConfirmationModal>
      )}
    </Modal>
  )
}
